import { getCoreUtils } from "../../../Admin/kReusableCoreTS/kCoreHandler";
import { AppFrameLoad } from "./AppFrameLoad";

/** Stable aliases coexist with the archive's established minute anchors. Installed before frame navigation. */
export class AppMessageAnchors {
    private Frame: HTMLIFrameElement | null = null;
    public Attach = (Frame: HTMLIFrameElement): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try { this.Frame = Frame; Frame.addEventListener("load", this.OnLoad); }
        catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMessageAnchors.Attach"); }
    };
    private OnLoad = (): void => {
        AppFrameLoad.Run(this.Frame, AppMessageAnchors.Install, "AppMessageAnchors.OnLoad");
    };
    public static Install = (Doc: Document): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            for (const Bubble of Array.from(Doc.querySelectorAll(".b[data-mid]"))) {
                const Id: string | null = Bubble.getAttribute("data-mid");
                if (Id === null || Id === "") { continue; }
                const Anchor: string = "msg-" + encodeURIComponent(Id);
                if (Doc.getElementById(Anchor) !== null) { continue; }
                const Alias: HTMLElement = Doc.createElement("span"); Alias.id = Anchor;
                Bubble.insertBefore(Alias, Bubble.firstChild);
            }
            const View: Window | null = Doc.defaultView;
            if (View === null || View.location.hash.startsWith("#msg-") === false) { return; }
            const Anchor: string = decodeURIComponent(View.location.hash.substring(1));
            const Alias: HTMLElement | null = Doc.getElementById(Anchor);
            if (Alias !== null && Alias.parentElement !== null) { Alias.parentElement.scrollIntoView({ block: "center" }); }
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMessageAnchors.Install"); }
    };
}
